module.exports = __webpack_public_path__ + "img/LMI_Pro.4370edde.png";